import React, { useEffect, useState } from "react";
import { Drawer, Form, Input, DatePicker, Icon, notification, Divider, Button, Checkbox, Radio, Row, Col } from "antd";
import axios from "axios";
import moment from "moment";
import SectionCard from "../../components/SectionCard";
import SectionDivider from "../../components/SectionDivider";

const { TextArea } = Input;

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({ message, description });
};

const parseObject = (value, fallback = {}) => {
    if (!value) return fallback;
    if (typeof value === "object" && !Array.isArray(value)) return value;
    try {
        const parsed = JSON.parse(value);
        return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : fallback;
    } catch {
        return fallback;
    }
};

const AREAS_CARACTERISTICAS = [
    { key: "vida_diaria", label: "Vida diária: autonomia/independência" },
    { key: "comunicacao_linguagem", label: "Comunicação/Linguagem" },
    { key: "motricidade_fina", label: "Motricidade fina" },
    { key: "motricidade_grossa", label: "Motricidade grossa" },
    { key: "habilidades_cognitivas", label: "Habilidades cognitivas: atenção, concentração, compreensão" },
    { key: "habilidades_interpessoais", label: "Habilidades interpessoais/afetivas" },
    { key: "habilidades_academicas", label: "Habilidades acadêmicas: leitura, escrita, cálculos matemáticos" }
];

const ITENS_AVALIACAO = [
    { secao: "LINGUAGEM - COMUNICAÇÃO" },
    { key: "expressa_clareza", label: "Se expressa com clareza?" },
    { key: "vocabulo_amplo", label: "Possui vocábulo amplo?" },
    { key: "transmite_recados", label: "Transmite recados?" },
    { key: "narra_experiencias", label: "Narra pequenas experiências pessoais?" },

    { secao: "LINGUAGEM ESCRITA" },
    { key: "escreve_nome", label: "Escreve seu nome?" },
    { key: "representa_letras", label: "Consegue representar graficamente as letras do alfabeto?" },
    { key: "escreve_palavras", label: "Escreve palavras?" },

    { secao: "LEITURA" },
    { key: "identifica_letras_nome", label: "Identifica todas as letras do seu nome?" },
    { key: "reconhece_alfabeto", label: "Reconhece todas as letras do alfabeto?" },
    { key: "identifica_inicial_final", label: "Identifica letra inicial e final de palavras?" },
    { key: "associa_palavras_imagem", label: "Associa palavras à imagem?" },
    { key: "le_palavras_simples", label: "Lê palavras simples?" },
    { key: "le_palavras_complexas", label: "Lê palavras complexas?" },
    { key: "le_textos", label: "Faz leitura de texto(s)?" },

    { secao: "ATENÇÃO E CONCENTRAÇÃO" },
    { key: "demora_tarefas", label: "Detém muito tempo na execução das tarefas?" },
    { key: "disperso", label: "É disperso e muda o foco da atividade para outra?" },
    { key: "agitado", label: "É agitado, não concluindo as atividades propostas?" },

    { secao: "PSICOMOTRICIDADE" },
    { key: "identifica_direita_esquerda", label: "Identifica direita e esquerda?" },
    { key: "nocao_espaco", label: "Tem noção de espaço (longe/perto, dentro/fora)?" },
    { key: "nocao_grandeza", label: "Tem noção de grandeza (maior/menor)?" },
    { key: "nocao_posicao", label: "Tem noção de posição (na frente/meio/atrás)?" },

    { secao: "COORDENAÇÃO VISOMOTORA" },
    { key: "coordenacao_motora", label: "Atira? Pega? Solta? Preensão palmar? Pinça? Rasga? Dobra? Modela?" },
    { key: "recorta_reta", label: "Recorta em linha reta?" },
    { key: "recorta_curva", label: "Recorta linha curva?" },
    { key: "pega_instrumentos", label: "Pega corretamente a caneta, tesoura, lápis, borracha?" },
    { key: "amarra_no", label: "Amarra nó?" },

    { secao: "MEMÓRIA VISUAL" },
    { key: "interpreta_gravuras", label: "Interpreta gravuras?" },
    { key: "memoriza_imagens", label: "Memoriza imagens?" },
    { key: "discrimina_objetos", label: "Discrimina objetos?" },
    { key: "monta_puzzles", label: "Monta quebra-cabeças e jogos de encaixe?" },
    { key: "identifica_figuras_iguais", label: "Identifica figuras iguais?" },

    { secao: "MEMÓRIA AUDITIVA" },
    { key: "identifica_sons", label: "Identifica os vários tipos de sons?" },
    { key: "percebe_estimulos", label: "Percebe estímulos sonoros?" },
    { key: "reproduz_sons", label: "Reproduz sons?" },

    { secao: "MATEMÁTICA – RACIOCÍNIO LÓGICO" },
    { key: "quantidade_numeral", label: "Relaciona a quantidade com o numeral?" },
    { key: "conta_oralmente", label: "Conta oralmente?" },
    { key: "realiza_adicao", label: "Realiza adição?" },
    { key: "realiza_subtracao", label: "Realiza subtração?" },
    { key: "figuras_geometricas", label: "Identifica figuras geométricas?" },
    { key: "cores_primarias", label: "Reconhece as cores primárias?" },
    { key: "diferencia_numeros", label: "Sabe diferenciar os números de outros símbolos?" },
    { key: "escreve_numeros", label: "Escreve os números?" },

    { secao: "ESTRUTURAÇÃO ESPAÇO/TEMPO" },
    { key: "nocao_espaco_geral", label: "Demonstra noção de espaço (sala de aula, casa, escola, etc.)?" },
    { key: "nocao_temporalidade", label: "Apresenta noções de temporalidade?" },
    { key: "organiza_historia", label: "Demonstra capacidade de organização de história em sequência através de gravuras?" },

    { secao: "MOVIMENTO E ARTES" },
    { key: "coord_motora_grossa", label: "Apresenta coordenação motora grossa?" },
    { key: "desenhos_detalhes", label: "Faz desenhos com riqueza de detalhes?" },
    { key: "pinta_linhas", label: "Pinta desenhos obedecendo as linhas?" },
    { key: "recorte_linhas", label: "Faz recorte obedecendo as linhas?" },
    { key: "modela_objetos", label: "Dá forma a objetos, animais e outros seres com massa de modelar?" }
];

const OPCOES_AVALIACAO = [
    { value: "ALC", label: "ALC – Alcançado" },
    { value: "EPR", label: "EPR – Em Processo" },
    { value: "NAL", label: "NAL – Não Alcançado" },
    { value: "NAV", label: "NAV – Não Avaliado" }
];

const TERAPIAS_FIXAS = ["Equoterapia", "Fisioterapia", "Fonoaudiologia", "Psicologia", "Terapia ocupacional"];

const ListaOutrosAtendimentosClinicos = ({ value = [], onChange }) => {
    const lista = value.length ? value : [];

    const handleChange = (index, field, fieldValue) => {
        const novaLista = [...lista];
        novaLista[index] = {
            ...novaLista[index],
            [field]: fieldValue
        };
        onChange && onChange(novaLista);
    };

    const handleAdd = () => {
        const novaLista = [
            ...lista,
            {
                nome: "",
                dias: "",
                horario: "",
                local: ""
            }
        ];
        onChange && onChange(novaLista);
    };

    const handleRemove = index => {
        const novaLista = lista.filter((_, i) => i !== index);
        onChange && onChange(novaLista);
    };

    return (
        <div>
            {lista.map((item, index) => (
                <div
                    key={index}
                    style={{
                        border: "1px solid #e8e8e8",
                        padding: 12,
                        marginBottom: 12,
                        borderRadius: 4
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: 8
                        }}
                    >
                        <strong>{index + 1}. Outro atendimento clínico</strong>
                        <Button type="danger" size="small" ghost icon="minus" onClick={() => handleRemove(index)} />
                    </div>

                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item label="Nome da terapia" style={{ marginBottom: 6 }}>
                                <Input value={item.nome} onChange={e => handleChange(index, "nome", e.target.value)} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Dias da semana" style={{ marginBottom: 6 }}>
                                <Input value={item.dias} onChange={e => handleChange(index, "dias", e.target.value)} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Horário" style={{ marginBottom: 6 }}>
                                <Input value={item.horario} onChange={e => handleChange(index, "horario", e.target.value)} />
                            </Form.Item>
                        </Col>

                        <Col span={8}>
                            <Form.Item label="Local" style={{ marginBottom: 6 }}>
                                <Input value={item.local} onChange={e => handleChange(index, "local", e.target.value)} />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
            ))}

            <Button type="dashed" icon="plus" onClick={handleAdd} style={{ width: "100%" }}>
                Adicionar outro atendimento clínico
            </Button>
        </div>
    );
};

const DrawerPlanoPEI = ({ id, pastaId, visible, atualizarListagem, onClose, form }) => {
    const estadoInicial = {
        apresentacao: {
            escola: "",
            periodo: "",
            aluno: "",
            idade: "",
            data_nascimento: null,
            serie: "",
            responsavel: "",
            professor_aee: "",
            professor_regular: "",
            laudo_medico: "",
            cid: "",
            deficiencias: [],
            transtornos: [],
            transtorno_outro: "",
            medicacao: "",
            horarios_medicacao: "",
            atendimento_aee: ""
        },
        atendimentos_clinicos: {
            ...TERAPIAS_FIXAS.reduce((acc, t) => {
                acc[t.toLowerCase().replace(/ /g, "_")] = { dias: "", horario: "", local: "" };
                return acc;
            }, {}),
            outros: []
        },
        caracteristicas_aluno: AREAS_CARACTERISTICAS.reduce((acc, a) => {
            acc[a.key] = { habilidades: "", dificuldades: "", artificios: "" };
            return acc;
        }, {}),
        intervencoes: {
            familiar: "",
            arquitetonico: "",
            atitudinal: "",
            pedagogico: "",
            outro: ""
        },
        registro_avancos: "",
        avaliacao: ITENS_AVALIACAO.filter(i => i.key).reduce((acc, i) => {
            acc[i.key] = null;
            return acc;
        }, {}),
        observacoes_complementares: ""
    };

    const [registo, setRegisto] = useState(estadoInicial);
    const [isLoading, setIsLoading] = useState(false);

    const { getFieldDecorator, setFieldsValue, resetFields, getFieldValue, validateFields } = form;

    const opcoesDeficiencias = ["Auditiva", "Física", "Intelectual", "Múltipla", "Visual"];
    const opcoesTranstornos = [
        "AHSD - Altas Habilidades ou Superlotação",
        "TEA - Transtorno do Espectro Autista",
        "TDAH - Transtorno do Déficit de Atenção e Hiperatividade",
        "Outros"
    ];

    const limparCampos = () => {
        resetFields();
        setRegisto(estadoInicial);
    };

    const handleSubmit = e => {
        e.preventDefault();
        validateFields((err, values) => {
            if (!err) {
                if (id) alterarPEI(values);
                else adicionarPEI(values);
            }
        });
    };

    const carregarDetalhe = id => {
        setIsLoading(true);

        axios({ method: "get", url: "/api/plano-atendimento/carregar-plano-atendimento-pei", params: { id } })
            .then(response => {
                const data = response.data;

                const apresentacao = parseObject(data.apresentacao, estadoInicial.apresentacao);
                const atendimentosClinicosParse = parseObject(data.atendimentos_clinicos, estadoInicial.atendimentos_clinicos);

                const atendimentos_clinicos = {
                    ...TERAPIAS_FIXAS.reduce((acc, t) => {
                        const key = t.toLowerCase().replace(/ /g, "_");
                        acc[key] = atendimentosClinicosParse[key] || { dias: "", horario: "", local: "" };
                        return acc;
                    }, {}),
                    outros: Array.isArray(atendimentosClinicosParse.outros) ? atendimentosClinicosParse.outros : []
                };

                const caracteristicas_aluno = parseObject(data.caracteristicas_aluno, estadoInicial.caracteristicas_aluno);
                const intervencoes = parseObject(data.intervencoes, estadoInicial.intervencoes);
                const avaliacao = parseObject(data.avaliacao, estadoInicial.avaliacao);

                const dados = {
                    apresentacao: {
                        ...apresentacao,
                        data_nascimento: apresentacao.data_nascimento ? moment(apresentacao.data_nascimento) : null,
                        deficiencias: Array.isArray(apresentacao.deficiencias) ? apresentacao.deficiencias : [],
                        transtornos: Array.isArray(apresentacao.transtornos) ? apresentacao.transtornos : []
                    },
                    atendimentos_clinicos,
                    caracteristicas_aluno,
                    intervencoes,
                    registro_avancos: data.registro_avancos || "",
                    avaliacao,
                    observacoes_complementares: data.observacoes_complementares || ""
                };

                setRegisto(dados);

                const fields = {
                    ident_escola: dados.apresentacao.escola || "",
                    ident_periodo: dados.apresentacao.periodo || "",
                    ident_aluno: dados.apresentacao.aluno || "",
                    ident_idade: dados.apresentacao.idade || "",
                    ident_data_nascimento: dados.apresentacao.data_nascimento,
                    ident_serie: dados.apresentacao.serie || "",
                    ident_responsavel: dados.apresentacao.responsavel || "",
                    ident_professor_aee: dados.apresentacao.professor_aee || "",
                    ident_professor_regular: dados.apresentacao.professor_regular || "",
                    ident_laudo_medico: dados.apresentacao.laudo_medico || "",
                    ident_cid: dados.apresentacao.cid || "",
                    ident_deficiencias: dados.apresentacao.deficiencias,
                    ident_transtornos: dados.apresentacao.transtornos,
                    ident_transtorno_outro: dados.apresentacao.transtorno_outro || "",
                    ident_medicacao: dados.apresentacao.medicacao || "",
                    ident_horarios_medicacao: dados.apresentacao.horarios_medicacao || "",
                    ident_atendimento_aee: dados.apresentacao.atendimento_aee || "",

                    interv_familiar: dados.intervencoes.familiar || "",
                    interv_arquitetonico: dados.intervencoes.arquitetonico || "",
                    interv_atitudinal: dados.intervencoes.atitudinal || "",
                    interv_pedagogico: dados.intervencoes.pedagogico || "",
                    interv_outro: dados.intervencoes.outro || "",

                    registro_avancos: dados.registro_avancos || "",
                    observacoes_complementares: dados.observacoes_complementares || "",
                    clinico_outros: dados.atendimentos_clinicos.outros || []
                };

                TERAPIAS_FIXAS.forEach(t => {
                    const key = t.toLowerCase().replace(/ /g, "_");
                    const terapia = dados.atendimentos_clinicos[key] || {};
                    fields[`clinico_${key}_dias`] = terapia.dias || "";
                    fields[`clinico_${key}_horario`] = terapia.horario || "";
                    fields[`clinico_${key}_local`] = terapia.local || "";
                });

                AREAS_CARACTERISTICAS.forEach(a => {
                    const area = dados.caracteristicas_aluno[a.key] || {};
                    fields[`carac_${a.key}_habilidades`] = area.habilidades || "";
                    fields[`carac_${a.key}_dificuldades`] = area.dificuldades || "";
                    fields[`carac_${a.key}_artificios`] = area.artificios || "";
                });

                ITENS_AVALIACAO.filter(i => i.key).forEach(i => {
                    fields[`aval_${i.key}`] = dados.avaliacao[i.key] || null;
                });

                setFieldsValue(fields);
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar detalhe.");
            })
            .finally(() => setIsLoading(false));
    };

    const montarPayload = values => {
        const atendimentos_clinicos = {
            ...TERAPIAS_FIXAS.reduce((acc, t) => {
                const key = t.toLowerCase().replace(/ /g, "_");
                acc[key] = {
                    dias: values[`clinico_${key}_dias`] || "",
                    horario: values[`clinico_${key}_horario`] || "",
                    local: values[`clinico_${key}_local`] || ""
                };
                return acc;
            }, {}),
            outros: values.clinico_outros || []
        };

        const caracteristicas_aluno = AREAS_CARACTERISTICAS.reduce((acc, a) => {
            acc[a.key] = {
                habilidades: values[`carac_${a.key}_habilidades`] || "",
                dificuldades: values[`carac_${a.key}_dificuldades`] || "",
                artificios: values[`carac_${a.key}_artificios`] || ""
            };
            return acc;
        }, {});

        const avaliacao = ITENS_AVALIACAO.filter(i => i.key).reduce((acc, i) => {
            acc[i.key] = values[`aval_${i.key}`] || null;
            return acc;
        }, {});

        return {
            id_disciplina: localStorage.getItem("codigo_curso"),
            tipo: "plano_atendimento_especializado_pei",

            apresentacao: JSON.stringify({
                escola: values.ident_escola || "",
                periodo: values.ident_periodo || "",
                aluno: values.ident_aluno || "",
                idade: values.ident_idade || "",
                data_nascimento: values.ident_data_nascimento ? values.ident_data_nascimento.format("YYYY-MM-DD") : null,
                serie: values.ident_serie || "",
                responsavel: values.ident_responsavel || "",
                professor_aee: values.ident_professor_aee || "",
                professor_regular: values.ident_professor_regular || "",
                laudo_medico: values.ident_laudo_medico || "",
                cid: values.ident_cid || "",
                deficiencias: values.ident_deficiencias || [],
                transtornos: values.ident_transtornos || [],
                transtorno_outro: values.ident_transtorno_outro || "",
                medicacao: values.ident_medicacao || "",
                horarios_medicacao: values.ident_horarios_medicacao || "",
                atendimento_aee: values.ident_atendimento_aee || ""
            }),

            atendimentos_clinicos: JSON.stringify(atendimentos_clinicos),
            caracteristicas_aluno: JSON.stringify(caracteristicas_aluno),

            intervencoes: JSON.stringify({
                familiar: values.interv_familiar || "",
                arquitetonico: values.interv_arquitetonico || "",
                atitudinal: values.interv_atitudinal || "",
                pedagogico: values.interv_pedagogico || "",
                outro: values.interv_outro || ""
            }),

            registro_avancos: values.registro_avancos || "",
            avaliacao: JSON.stringify(avaliacao),
            observacoes_complementares: values.observacoes_complementares || ""
        };
    };

    const adicionarPEI = values => {
        setIsLoading(true);
        axios({ method: "post", url: "/api/plano-atendimento/adicionar-plano-atendimento-pei", data: montarPayload(values) })
            .then(response => {
                openNotificationWithIcon("success", "Sucesso", "PEI criado com sucesso.");
                atualizarListagem(response.data);
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao criar o PEI.");
            })
            .finally(() => setIsLoading(false));
    };

    const alterarPEI = values => {
        setIsLoading(true);
        axios({
            method: "put",
            url: "/api/plano-atendimento/alterar-plano-atendimento-pei",
            params: { id },
            data: { ...montarPayload(values) }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "PEI alterado com sucesso.");
                atualizarListagem();
                handleClose();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao alterar o PEI.");
            })
            .finally(() => setIsLoading(false));
    };

    const carregarDadosAluno = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes",
            params: {
                pastaId,
                turmaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    apresentacao: {
                        ...prevState.apresentacao,
                        escola: turma?.escola || "",
                        aluno: aluno?.nome || "",
                        serie: turma?.nome || "",
                        idade: aluno?.idade ?? null,
                        data_nascimento: aluno?.dataNascimento ? moment(aluno.dataNascimento) : null,
                        professor_regular: turma?.professor || ""
                    }
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const carregarDadosAlunoEnsinoEspecial = () => {
        axios({
            method: "get",
            url: "/api/estudo-caso/carregar-informacoes-ensino-especial",
            params: {
                disciplinaId: localStorage.getItem("codigo_curso")
            }
        })
            .then(response => {
                const { aluno, turma } = response.data;

                setRegisto(prevState => ({
                    ...prevState,
                    apresentacao: {
                        ...prevState.apresentacao,
                        escola: turma?.escola || "",
                        aluno: aluno?.nome || "",
                        serie: turma?.nome || "",
                        idade: aluno?.idade ?? null,
                        data_nascimento: aluno?.dataNascimento ? moment(aluno.dataNascimento) : null,
                        professor_regular: turma?.professor || ""
                    }
                }));
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao carregar dados.");
            });
    };

    const handleClose = () => {
        onClose();
    };

    const afterVisibleChange = aberto => {
        if (!aberto) {
            limparCampos();
        }
    };

    useEffect(() => {
        if (visible && id) {
            carregarDetalhe(id);
        }

        if (pastaId && visible) {
            carregarDadosAluno();
        }

        if (visible && !id && !pastaId) {
            setRegisto(estadoInicial);
            carregarDadosAlunoEnsinoEspecial();
            resetFields();
        }
    }, [id, visible]);

    const temOutroTranstorno = (getFieldValue("ident_transtornos") || []).includes("Outros");

    return (
        <Drawer
            className="drawer-adicionar-evento drawer-add-cursos"
            width={800}
            onClose={handleClose}
            visible={visible}
            style={{ overflow: "auto", height: "calc(100% - 108px)", paddingBottom: "108px" }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias" layout="horizontal" onSubmit={handleSubmit}>
                    <SectionCard title="Identificação">
                        <Form.Item label="Escola">
                            {getFieldDecorator("ident_escola", {
                                initialValue: registo.apresentacao.escola,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Período">
                            {getFieldDecorator("ident_periodo", {
                                initialValue: registo.apresentacao.periodo,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Aluno(a)">
                            {getFieldDecorator("ident_aluno", {
                                initialValue: registo.apresentacao.aluno,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Idade">
                            {getFieldDecorator("ident_idade", {
                                initialValue: registo.apresentacao.idade,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Data de nascimento">
                            {getFieldDecorator("ident_data_nascimento", {
                                initialValue: registo.apresentacao.data_nascimento,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />)}
                        </Form.Item>

                        <Form.Item label="Série">
                            {getFieldDecorator("ident_serie", {
                                initialValue: registo.apresentacao.serie,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Responsável">
                            {getFieldDecorator("ident_responsavel", {
                                initialValue: registo.apresentacao.responsavel,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professor(a) AEE">
                            {getFieldDecorator("ident_professor_aee", {
                                initialValue: registo.apresentacao.professor_aee,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Professor(a) regular">
                            {getFieldDecorator("ident_professor_regular", {
                                initialValue: registo.apresentacao.professor_regular,
                                rules: [{ required: true, message: "Campo obrigatório" }]
                            })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Laudo Médico">
                            {getFieldDecorator("ident_laudo_medico", { initialValue: registo.apresentacao.laudo_medico })(<Input />)}
                        </Form.Item>

                        <Form.Item label="CID">
                            {getFieldDecorator("ident_cid", { initialValue: registo.apresentacao.cid })(<Input />)}
                        </Form.Item>

                        <Form.Item label="Deficiência">
                            {getFieldDecorator("ident_deficiencias", { initialValue: registo.apresentacao.deficiencias })(
                                <Checkbox.Group style={{ width: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                        {opcoesDeficiencias.map(d => (
                                            <Checkbox key={d} value={d}>
                                                {d}
                                            </Checkbox>
                                        ))}
                                    </div>
                                </Checkbox.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Transtorno">
                            {getFieldDecorator("ident_transtornos", { initialValue: registo.apresentacao.transtornos })(
                                <Checkbox.Group style={{ width: "100%" }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                        {opcoesTranstornos.map(t => (
                                            <Checkbox key={t} value={t}>
                                                {t}
                                            </Checkbox>
                                        ))}
                                    </div>
                                </Checkbox.Group>
                            )}
                        </Form.Item>

                        <Form.Item label="Especifique o transtorno">
                            {getFieldDecorator("ident_transtorno_outro", { initialValue: registo.apresentacao.transtorno_outro })(
                                <Input disabled={!temOutroTranstorno} />
                            )}
                        </Form.Item>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Medicação">
                                    {getFieldDecorator("ident_medicacao", { initialValue: registo.apresentacao.medicacao })(<Input />)}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Horários">
                                    {getFieldDecorator("ident_horarios_medicacao", {
                                        initialValue: registo.apresentacao.horarios_medicacao
                                    })(<Input />)}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item label="Atendimento Educacional Especializado (dias e horários)">
                            {getFieldDecorator("ident_atendimento_aee", { initialValue: registo.apresentacao.atendimento_aee })(
                                <TextArea rows={3} style={{ minHeight: 100 }} />
                            )}
                        </Form.Item>

                        <Divider orientation="left" style={{ fontWeight: "bold" }}>
                            Atendimentos Clínicos
                        </Divider>

                        {TERAPIAS_FIXAS.map(terapia => {
                            const key = terapia.toLowerCase().replace(/ /g, "_");
                            const dados = registo.atendimentos_clinicos[key] || {};

                            return (
                                <div key={key} style={{ marginBottom: 12 }}>
                                    <div style={{ fontWeight: "bold", marginBottom: 6, fontSize: 13 }}>{terapia}</div>
                                    <Row gutter={12}>
                                        <Col span={8}>
                                            <Form.Item label="Dias da semana" style={{ marginBottom: 6 }}>
                                                {getFieldDecorator(`clinico_${key}_dias`, { initialValue: dados.dias })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="Horário" style={{ marginBottom: 6 }}>
                                                {getFieldDecorator(`clinico_${key}_horario`, { initialValue: dados.horario })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="Local" style={{ marginBottom: 6 }}>
                                                {getFieldDecorator(`clinico_${key}_local`, { initialValue: dados.local })(<Input />)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })}

                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontWeight: "bold", marginBottom: 6, fontSize: 13 }}>Outros</div>

                            <div style={{ fontSize: 12, color: "#888", marginBottom: 10 }}>
                                Adicione abaixo os atendimentos clínicos adicionais. Se não houver, este campo permanece vazio.
                            </div>

                            <Form.Item style={{ marginBottom: 0 }}>
                                {getFieldDecorator("clinico_outros", {
                                    initialValue: registo.atendimentos_clinicos.outros || []
                                })(<ListaOutrosAtendimentosClinicos />)}
                            </Form.Item>
                        </div>
                    </SectionCard>

                    <SectionCard title="1. Características do Aluno">
                        <Row gutter={8} style={{ fontWeight: "bold", marginBottom: 8, padding: "0 4px" }}>
                            <Col span={6}>
                                <span style={{ fontSize: 12 }}>Área</span>
                            </Col>
                            <Col span={6}>
                                <span style={{ fontSize: 12 }}>Habilidades</span>
                            </Col>
                            <Col span={6}>
                                <span style={{ fontSize: 12 }}>Dificuldades</span>
                            </Col>
                            <Col span={6}>
                                <span style={{ fontSize: 12 }}>Artifícios e recursos didáticos</span>
                            </Col>
                        </Row>

                        {AREAS_CARACTERISTICAS.map(area => {
                            const dados = registo.caracteristicas_aluno[area.key] || {};
                            return (
                                <div key={area.key} style={{ marginBottom: 8, padding: "8px 4px", borderBottom: "1px solid #f0f0f0" }}>
                                    <Row gutter={8} align="middle">
                                        <Col span={6}>
                                            <span style={{ fontSize: 12 }}>{area.label}</span>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item style={{ marginBottom: 0 }}>
                                                {getFieldDecorator(`carac_${area.key}_habilidades`, { initialValue: dados.habilidades })(
                                                    <TextArea rows={2} placeholder="Habilidades..." style={{ minHeight: 60 }} />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item style={{ marginBottom: 0 }}>
                                                {getFieldDecorator(`carac_${area.key}_dificuldades`, { initialValue: dados.dificuldades })(
                                                    <TextArea rows={2} placeholder="Dificuldades..." style={{ minHeight: 60 }} />
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}>
                                            <Form.Item style={{ marginBottom: 0 }}>
                                                {getFieldDecorator(`carac_${area.key}_artificios`, { initialValue: dados.artificios })(
                                                    <TextArea rows={2} placeholder="Artifícios..." style={{ minHeight: 60 }} />
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            );
                        })}
                    </SectionCard>

                    <SectionCard title="2. Tipo de Intervenções Necessárias">
                        {[
                            { key: "familiar", label: "Familiar" },
                            { key: "arquitetonico", label: "Arquitetônico/mobiliário" },
                            { key: "atitudinal", label: "Atitudinal" },
                            { key: "pedagogico", label: "Pedagógico" },
                            { key: "outro", label: "Outro" }
                        ].map(item => (
                            <Form.Item key={item.key} label={item.label}>
                                {getFieldDecorator(`interv_${item.key}`, { initialValue: registo.intervencoes[item.key] })(
                                    <TextArea rows={5} style={{ minHeight: 100 }} />
                                )}
                            </Form.Item>
                        ))}
                    </SectionCard>

                    <SectionCard title="3. Registro dos Avanços e Dificuldades">
                        <Form.Item label="Registro ao longo do período">
                            {getFieldDecorator("registro_avancos", { initialValue: registo.registro_avancos })(
                                <TextArea rows={5} style={{ minHeight: 100 }} />
                            )}
                        </Form.Item>
                    </SectionCard>

                    <SectionCard title="4. Avaliação">
                        <div style={{ marginBottom: 15, marginTop: 15 }}>
                            <div style={{ marginBottom: 8, padding: "6px 8px", background: "#f5f5f5", borderRadius: 4, fontSize: 12 }}>
                                <strong>Legenda:</strong> ALC = Alcançado &nbsp;|&nbsp; EPR = Em Processo &nbsp;|&nbsp; NAL = Não Alcançado
                                &nbsp;|&nbsp; NAV = Não Avaliado
                            </div>
                            {ITENS_AVALIACAO.map((item, index) => {
                                if (item.secao) {
                                    return (
                                        <div
                                            key={`secao_${index}`}
                                            style={{
                                                background: "#d9ead3",
                                                padding: "6px 10px",
                                                fontWeight: "bold",
                                                fontSize: 12,
                                                marginTop: 12,
                                                marginBottom: 4,
                                                borderRadius: 3
                                            }}
                                        >
                                            {item.secao}
                                        </div>
                                    );
                                }

                                const dadosAval = registo.avaliacao[item.key];
                                return (
                                    <div key={item.key} style={{ padding: "4px 8px", borderBottom: "1px solid #f0f0f0" }}>
                                        <Row align="middle" gutter={8}>
                                            <Col span={14}>
                                                <span style={{ fontSize: 12 }}>{item.label}</span>
                                            </Col>
                                            <Col span={10}>
                                                <Form.Item style={{ marginBottom: 0 }}>
                                                    {getFieldDecorator(`aval_${item.key}`, { initialValue: dadosAval })(
                                                        <Radio.Group size="small">
                                                            {OPCOES_AVALIACAO.map(op => (
                                                                <Radio key={op.value} value={op.value} style={{ fontSize: 11 }}>
                                                                    {op.value}
                                                                </Radio>
                                                            ))}
                                                        </Radio.Group>
                                                    )}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </div>
                                );
                            })}
                        </div>
                    </SectionCard>

                    <SectionCard title="Observações Complementares">
                        <Form.Item>
                            {getFieldDecorator("observacoes_complementares", { initialValue: registo.observacoes_complementares })(
                                <TextArea rows={5} style={{ minHeight: 100 }} />
                            )}
                        </Form.Item>
                    </SectionCard>

                    <div className="ant-drawer-footer">
                        <button
                            className="botao-secundario"
                            type="button"
                            onClick={handleClose}
                            style={{ marginRight: 20, display: "inline-block" }}
                        >
                            Cancelar
                        </button>
                        <button className="botao-principal" type="submit" disabled={isLoading}>
                            {isLoading ? <Icon type="loading" /> : null}
                            Salvar
                        </button>
                    </div>
                </Form>
            </div>
        </Drawer>
    );
};

export default Form.create({ name: "form-drawer-adicionar-pei" })(DrawerPlanoPEI);
